import React from 'react';

interface StatusBarProps {
  trackName: string;
  trackLayout: string;
  trackLength: number;
  lapsLoaded: number;
}

const StatusBar: React.FC<StatusBarProps> = ({ trackName, trackLayout, trackLength, lapsLoaded }) => (
  <footer className="tele-status-bar">
    <div className="tele-status-left">
      <span>Track: {trackName}</span>
      <span>Length: {Math.round(trackLength * 3.28084).toLocaleString()} ft</span>
      <span className="tele-status-green">Telemetry: {lapsLoaded} lap{lapsLoaded !== 1 ? 's' : ''} loaded</span>
    </div>
    <div className="tele-status-right">
      <span>Esc to reset zoom</span>
      <span>Arrow keys to navigate</span>
    </div>
  </footer>
);

export default StatusBar;
